import { INTENSITY_LEVELS } from '@/lib/narrative-levels';
import { cn } from '@/lib/utils';

export function IntensityLegend({ className }: { className?: string }) {
  return (
    <div className={cn('flex gap-3 text-[10px] text-pelip-text-faint', className)}>
      {INTENSITY_LEVELS.map((level) => (
        <span key={level.label} className="flex items-center gap-1">
          <span className={cn('w-2 h-2 rounded-full', level.dotClass)} />
          {level.label} ({level.min}-{level.max})
        </span>
      ))}
    </div>
  );
}
